<template>
<b-row>
    <b-colxx xxs="12">
        <h1>{{ $t('menu.siteSet') }}</h1>
        <piaf-breadcrumb />
        <b-row>
            <modal_postcode ref="modal_postcode" @confirm="selectAddress" />
            <modal_image ref="modal_image" :data="siteInfo.registrationNumberUrl" />
            <b-colxx xxs="12">
                <!-- <b-card class="mb-4" title="">
                    <b-form-group label-cols="2" horizontal label="메인 노출 이미지" class="weight600">
                        <b-form-row>
                            <store-file-uploader :sortable="'handle'" :container="'STORE'" :compact="false" :maxFiles="10" :defaultFiles="brandImages" @getFileData="getbrandImagesFiles"></store-file-uploader>
                        </b-form-row>
                    </b-form-group>
                    <div class="text-center">
                        <b-button variant="primary" @click.prevent="siteImagesUpdate">저장</b-button>
                    </div>
                </b-card> -->
                <b-card class="mb-4" title="사이트 관리 등록">
                    <b-form-group label-cols="2" horizontal label="대표자" class="weight600">
                        <b-form-input v-model="siteInfo.representative" placeholder="" maxlength="40"></b-form-input>
                    </b-form-group>

                    <b-form-group label-cols="2" horizontal label="주소" class="weight600">
                        <b-input-group class="col-9 pl-0">
                            <b-form-input placeholder="" type="text" v-model="siteInfo.address" disabled></b-form-input>
                            <b-form-input placeholder="" type="text" v-model="siteInfo.detailAddress"></b-form-input>

                            <b-input-group-append>
                                <b-button variant="outline-secondary" @click="searchAddress">{{ $t('button.search-address') }}</b-button>
                            </b-input-group-append>

                        </b-input-group>
                    </b-form-group>

                    <b-form-group label-cols="2" horizontal label="개인정보관리자" class="weight600">
                        <b-form-input v-model="siteInfo.privacyPolicyManager" placeholder=""></b-form-input>
                    </b-form-group>

                    <b-form-group label-cols="2" horizontal label="이메일주소" class="weight600">
                        <b-form-input v-model="siteInfo.privacyPolicyManagerEmail" placeholder="" maxlength="40"></b-form-input>
                    </b-form-group>

                    <b-form-group label-cols="2" horizontal label="이용약관" class="weight600">
                        <b-form-textarea v-model="siteInfo.termsOfService" :rows="4" :max-rows="4" />
                    </b-form-group>

                    <b-form-group label-cols="2" horizontal label="개인정보 취급방침" class="weight600">
                        <b-form-textarea v-model="siteInfo.privacyStatement" :rows="4" :max-rows="4" />
                    </b-form-group>

                    <b-form-group label-cols="2" horizontal label="도메인" class="weight600">
                        <span>{{ siteInfo.domainUrl }}</span>
                    </b-form-group>
                    <b-form-group label-cols="2" horizontal label="고객센터" class="weight600">
                        <b-form-input v-model="siteInfo.centerNumber" placeholder="" maxlength="40"></b-form-input>
                    </b-form-group>
                    <div class="text-center">
                        <b-button variant="primary" @click.prevent="onSaveFiles">저장</b-button>
                    </div>
                </b-card>
                <b-card class="mb-4" title="">
                    <b-form-group label-cols="2" horizontal label="사이트 컬러" class="weight600">
                        <b-form-row>
                            <div class="bv-no-focus-ring col row">
                                <div class="warp-div-color col-4">
                                    <div v-for="(coloritem,idx) in colorArr" :key="idx" class="colorDiv">
                                        <span class="mr-2"> {{ coloritem.name }} </span>
                                        <div>
                                            <div :style="{'background-color':''+coloritem.colorName.hex+''}" class="colorbox1" v-if="nullColor"></div>
                                            <div v-else class="nullColor"></div>
                                            <button type="button" @click="colorChange(idx + 1)" :class="colorIndex == idx + 1 ? 'colorchoiseon':''">컬러 선택</button>
                                            <span class="d-inline-block" style="color: #909090; text-decoration: underline" v-b-tooltip.hover="{ variant: 'info'}" :title="coloritem.info">
                                                <b-icon icon="info" class="biconinfo"></b-icon>
                                            </span>
                                        </div>
                                    </div>
                                    <button type="button" class="setBtn" @click="setColor">초기화</button>
                                </div>
                                <div class="showcolor col-8" v-if="showColor">
                                    <Chrome v-model="colors1"></Chrome>
                                    <div>
                                        <button type="button" class="choiseBtn" @click="showColorClick">확인</button>
                                        <button type="button" @click="hideColor">취소</button>
                                    </div>
                                </div>
                            </div>
                        </b-form-row>
                    </b-form-group>
                    <div class="text-center">
                        <b-button variant="primary" @click.prevent="siteColorUpdate">저장</b-button>
                    </div>
                </b-card>
              <b-card class="mb-4" title="">
                <b-form-group label-cols="2" horizontal label="추천 선물 메시지" class="weight600">
                  <b-form-tags v-model="giftMessages" no-outer-focus class="mb-2">
                    <template v-slot="{ tags, inputAttrs, inputHandlers, tagVariant, addTag, removeTag }">

                      <b-input-group class="mb-2">
                        <b-form-input v-bind="inputAttrs" v-on="inputHandlers" placeholder="선물 메시지를 입력하세요. (최대100자)"
                                      class="form-control" maxlength='100'></b-form-input>
                        <b-input-group-append>
                          <b-button style="width: 100px;" @click="addTag()" variant="outline-secondary">추가</b-button>
                        </b-input-group-append>
                      </b-input-group>
                      <div class="d-inline-block" style="font-size: 17px;">
                        <b-form-tag v-for="tag in tags" @remove="removeTag(tag)" :key="tag" :title="tag"
                                    variant="outline-primary" class="mr-1">{{ tag }}
                        </b-form-tag>
                      </div>
                    </template>
                  </b-form-tags>
                </b-form-group>
                <div class="text-center">
                  <b-button variant="primary" @click.prevent="siteGiftMessageUpdate">저장</b-button>
                </div>
              </b-card>
            </b-colxx>

        </b-row>
    </b-colxx>

</b-row>
</template>

<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import {
    mapGetters,
    mapActions
} from "vuex";
import {
    Chrome,
    Swatches
} from 'vue-color';
import ModalPostcode from "../shop/components/ModalPostcode.vue";
import ModalImage from '../shop/components/ModalImage';
import StoreFileUploader from "../../components/Upload/StoreFileUploader.vue";
import api from '../../constants/api';

export default {
    components: {
        Chrome,
        Swatches,
        'v-select': vSelect,
        'modal_postcode': ModalPostcode,
        'modal_image': ModalImage,
        'store-file-uploader': StoreFileUploader,

    },
    computed: {
        ...mapGetters(['currentUser', 'siteName'])
    },
    mounted() {
        this.lodaData();
    },
    data() {
        return {
            nullColor: true,
            colorArr: [{
                    name: '메인컬러',
                    info: '주요 표시에 사용되는 컬러입니다. Ex) 할인율, 강조표시, 선택 표시 등',
                    colorName: {
                        name: 'mainColor',
                        hex: '#EC632A',
                        hsl: {},
                        hsv: {},
                        rgba: {},
                        a: 1
                    },
                },
                {
                    name: '서브컬러',
                    info: '기본 표시에 사용되는 컬러입니다. Ex) 예약시간 리스트, 기능 버튼 등',
                    colorName: {
                        name: 'subColor',
                        hex: '#7C726E',
                        hsl: {},
                        hsv: {},
                        rgba: {},
                        a: 1
                    },
                },
                {
                    name: '안내컬러',
                    info: '안내문구 메시지 안내시 사용되는 컬러 입니다. Ex) 회원정보수정완료 등',
                    colorName: {
                        name: 'guideColor',
                        hex: '#26a69a',
                        hsl: {},
                        hsv: {},
                        rgba: {},
                        a: 1
                    },
                },
                {
                    name: '에러컬러',
                    info: '에러 메시지 안내시 사용되는 컬러 입니다. Ex) 이용불가 안내 등',
                    colorName: {
                        name: 'errorColor',
                        hex: '#D84315',
                        hsl: {},
                        hsv: {},
                        rgba: {},
                        a: 1
                    },
                },
            ],
            showColor: false,
            colorIndex: '0',
            colors1: {
                hex: '#194d33',
                hsl: {
                    h: 150,
                    s: 0.5,
                    l: 0.2,
                    a: 1
                },
                hsv: {
                    h: 150,
                    s: 0.5,
                    l: 0.2,
                    a: 1
                },
                rgba: {
                    r: 25,
                    g: 77,
                    b: 51,
                    a: 1
                },
                a: 1
            },
            brandCode: '',
            brandImages: [],
            siteInfo: {
                brandImages: [],
                address: '',
                detailAddress: '',
                privacyPolicyManager: '',
                privacyPolicyManagerEmail: '',
                termsOfService: '',
                privacyStatement: '',
                centerNumber: '',
                domainUrl: '',
            },
            giftMessages: []
        }
    },
    methods: {
        siteGiftMessageQuery() {
          const reqURL = api.changeAPI(this.siteName, api.basicURL + api.siteSet.siteGiftMessageQuery);

          this.$http.get(reqURL, {
            params: '',
            headers: {
              'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
            }
          }).then(res =>{
            if(res.data.code ==="OK"){
              this.giftMessages = res.data.data.brandGiftMessageUnitDto.giftMessages;
            }
          });


        },
        siteGiftMessageUpdate() {
          const params = {
            brandGiftMessageUnitDto:{
              giftMessages: this.giftMessages
            }
          }
          const reqURL = api.changeAPI(this.siteName, api.basicURL + api.siteSet.siteGiftMessageUpdate);

          this.$http.post(reqURL, params, {
            headers: {
              'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
            }
          }).then(res => {
            if (res.data.code === "OK") {
              alert('저장 되었습니다.')
            } else {
              throw 400
            }
          }).catch(err => {
            alert(err.response.data.message);
          })


        },
        siteColorQuery() {
            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.siteSet.siteColorQuery);

            this.$http.get(reqURL, {
                params: '',
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    if (res.data.data.siteColorUnitDto.errorColor === null) {
                        this.setColor();
                    }
                    const siteuu = res.data.data.siteColorUnitDto;

                    this.colorArr.forEach((el, idx) => {
                        if (siteuu[el.colorName.name] !== null) {
                            el.colorName.hex = siteuu[el.colorName.name];
                        }
                    });

                    let newArrr = [];
                    this.colorArr.forEach(el => {
                        newArrr.push(this.hexToRgb(el.colorName.hex, false))
                    });

                    this.colorArr.forEach((el, idx) => {
                        el.colorName.rgba = newArrr[idx];
                        el.colorName.hsl = this.rgb2hsl(this.hexToRgb(el.colorName.hex, true));
                    });

                } else {
                    throw 400
                }
            }).catch(err => {
                console.log(err);
            })
        },
        siteImagesUpdate() {
            const params = {
                siteImages: {
                    brandImages: this.siteInfo.brandImages
                },
            }
            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.siteSet.siteImageUpdate);

            this.$http.post(reqURL, params, {
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    alert('저장 되었습니다.')
                } else {
                    throw 400
                }
            }).catch(err => {
                alert(err.response.data.message);
            })
        },
        hexToRgb(hexValue, hslchange) {
            const rgx = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
            const hex = hexValue.replace(rgx, (m, r, g, b) => r + r + g + g + b + b);
            const rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            const r = parseInt(rgb[1], 16);
            const g = parseInt(rgb[2], 16);
            const b = parseInt(rgb[3], 16);
            let rebarr;
            if (hslchange) {
                rebarr = [r, g, b];
            } else {
                rebarr = {
                    r: r,
                    g: g,
                    b: b,
                    a: 1,
                };
            }
            return rebarr;
        },
        rgb2hsl(color) {
            var r = color[0] / 255;
            var g = color[1] / 255;
            var b = color[2] / 255;
            var max = Math.max(r, g, b),
                min = Math.min(r, g, b);
            var h, s, l = (max + min) / 2;

            if (max == min) {
                h = s = 0; // achromatic
            } else {
                var d = max - min;
                s = (l > 0.5 ? d / (2 - max - min) : d / (max + min));

                switch (max) {
                    case r:
                        h = (g - b) / d + (g < b ? 6 : 0);
                        break;
                    case g:
                        h = (b - r) / d + 2;
                        break;
                    case b:
                        h = (r - g) / d + 4;
                        break;
                }

                h /= 6;
            }
            return {
                h: h * 360,
                s: s * 100,
                l: l * 100,
                a: 1
            };
        },
        siteColorUpdate() {
            let nullColorpoint = true;
            let forarr = [];
            this.colorArr.forEach(el => {
                if (el.colorName.hex === null) {
                    forarr.push(1)
                    nullColorpoint = false;
                }
            });
            if (!nullColorpoint && forarr.length !== 4) {
                alert('컬러를 선택해주세요.')
            } else {
                const params = {
                    siteColorUnitDto: {
                        mainColor: this.colorArr[0].colorName.hex,
                        subColor: this.colorArr[1].colorName.hex,
                        guideColor: this.colorArr[2].colorName.hex,
                        errorColor: this.colorArr[3].colorName.hex
                    },
                }
                const reqURL = api.changeAPI(this.siteName, api.basicURL + api.siteSet.siteColorUpdate);

                this.$http.post(reqURL, params, {
                    headers: {
                        'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                    }
                }).then(res => {
                    if (res.data.code === "OK") {
                        alert('저장 되었습니다.')
                    } else {
                        throw 400
                    }
                }).catch(err => {
                    alert(err.response.data.message);
                })
            }
        },
        setColor() {
            this.hideColor();
            this.colorArr.forEach(el => {
                el.colorName.hex = null;
            });
            this.nullColor = false;

        },
        hideColor() {
            this.showColor = false;
            this.colorIndex = '0';
        },
        showColorClick() {
            this.showColor = false;
            switch (this.colorIndex) {
                case 1:
                    this.colors1.name = 'mainColor';
                    this.colorArr[0].colorName = this.colors1;
                    break;
                case 2:
                    this.colors1.name = 'subColor';
                    this.colorArr[1].colorName = this.colors1;
                    break;
                case 3:
                    this.colors1.name = 'guideColor';
                    this.colorArr[2].colorName = this.colors1;
                    break;
                case 4:
                    this.colors1.name = 'errorColor';
                    this.colorArr[3].colorName = this.colors1;
                    break;
            }
            this.colorIndex = '0';
        },
        colorChange(idx) {
            this.nullColor = true;
            switch (idx) {
                case 1:
                    this.colors1 = this.colorArr[0].colorName;
                    break;
                case 2:
                    this.colors1 = this.colorArr[1].colorName;
                    break;
                case 3:
                    this.colors1 = this.colorArr[2].colorName;
                    break;
                case 4:
                    this.colors1 = this.colorArr[3].colorName;
                    break;
            }
            this.colorIndex = idx;
            this.showColor = true;
        },
        onSaveFiles() {
            const params = {
                brandCode: this.brandCode,
                siteInfo: this.siteInfo
            }
            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.siteSet.siteInfoUpdate);

            this.$http.post(reqURL, params, {
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    alert('저장 되었습니다.')
                } else {
                    throw 400
                }
            }).catch(err => {
                alert(err.response.data.message);
            })
        },
        lodaData() {
            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.siteSet.siteQuery);

            this.$http.get(reqURL, {
                params: '',
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    const _data = res.data.data;
                    this.siteInfo = _data.siteInfo;
                    this.brandCode = _data.brandCode;
                    this.siteColorQuery();
                    this.siteImagesQuery();
                    this.siteGiftMessageQuery();
                } else {
                    throw 400
                }
            }).catch(err => {
                console.log(err);
            })
        },
        selectAddress(data) {
            this.siteInfo.detailAddress = data.data.detailAddress
            this.siteInfo.address = data.data.roadAddress
        },
        searchAddress() {
            this.$refs.modal_postcode.open()
        },
        siteImagesQuery() {
            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.siteSet.siteImageQuery + '?brandCode=' + this.brandCode);

            this.$http.get(reqURL, {
                params: '',
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    let vm = this;
                    const _data = res.data.data;
                    _data.siteImages.brandImages.forEach(function (val, index) {
                        vm.brandImages.push({
                            "name": "TestName.jpg",
                            "size": 20000,
                            "type": "image/jpeg",
                            "ext": "jpg",
                            "url": val.url,
                            "height": val.height,
                            "width": val.width
                        })
                    })
                } else {
                    throw 400
                }
            }).catch(err => {
                console.log(err);
            })
        },
        getbrandImagesFiles(fileData) {
            if (fileData.length > 0) {
                let vm = this
                this.siteInfo.brandImages = []

                fileData.forEach(function (value, index) {
                    let _url = value.azureUrl ? value.azureUrl : value.url;

                    vm.siteInfo.brandImages.push({
                        width: value.width,
                        height: value.height,
                        url: _url,
                        azureUrl: _url
                    })
                })

            } else {
                this.siteInfo.brandImages = []
            }
        },
    }
}
</script>

<style>
.colorbox1 {
    min-height: 29px;
    width: 29px;
}

.colorDiv {
    display: -webkit-box;
    display: -ms-flexbox;
    /* display: flex; */
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    /* width: 100%; */
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-bottom: 16px;
    margin-left: 20px;
    margin-top: 20px;
    max-width: 209px;
}

.biconinfo {
    width: 29px;
    height: 29px;
    margin-left: 5px;
}

.colorDiv>div>div {
    margin-right: 10px;
}

.colorDiv>div {
    display: flex;
}

.warp-div-color {
    width: 100%;
}

.showcolor>div>button {
    background: none;
    border: 1px solid #ababab;
    margin-top: 22px;
    padding: 5px 17px;
}

.showcolor>div {
    width: 225px;
}

.showcolor {
    text-align: center;
}

.colorDiv>div>button {
    background: none;
    border: 1px solid #646464;
    color: #646464;
    padding: 3px 13px;
}

.colorchoiseon {
    background: #959595 !important;
    color: #fff !important;
    border: 1px solid #fff !important;
    font-weight: 600;
}

.setBtn {
    background: none;
    border: 1px solid #ababab;
    margin-top: 22px;
    padding: 5px 17px;
    margin-left: 20px;
}

.showcolor>div>button.choiseBtn {
    background: #ec632a;
    color: #fff;
    border: 1px solid #ec632a;
}

.vc-alpha {
    display: none;
}

.nullColor {
    background: url('/assets/img/x.png');
    background-repeat: no-repeat;
    background-position: center;
    width: 21px;
    height: 26px;
    background-size: contain;
}
.tooltip.b-tooltip {
    top: -146px!important;
}
</style>
